/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Share_Created_TitleInputs */



/**
* | output |
* | --- |
* | "Share created" |
*
* @param {Team_Share_Created_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_share_created_title = /** @type {((inputs?: Team_Share_Created_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Share_Created_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Share created")
	if (locale === "de") return /** @type {LocalizedString} */ ("Share created")
	if (locale === "it") return /** @type {LocalizedString} */ ("Share created")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Share created")
	if (locale === "es") return /** @type {LocalizedString} */ ("Share created")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Share created")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Share created")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Share created")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Share created")
	return /** @type {LocalizedString} */ ("Share created")
});